import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { kailuaConfig } from "./data";

export default function KailuaPage() {
  return <CityPageTemplate config={kailuaConfig} />;
}